<template>
  <div class="print-pay-fee-beilin-container" :class="['paper-' + paperType, { 'edit-mode': editMode }]">
    <!-- 编辑模式开关（打印时隐藏） -->
    <div class="edit-toolbar">
      <el-checkbox v-model="editMode">编辑模式（勾选后可点击收据内容直接修改，打印前请取消勾选）</el-checkbox>
    </div>

    <!-- 标题 -->
    <div class="receipt-title" :contenteditable="editMode">西安碑林物业管理有限公司收款收据</div>

    <!-- 头部信息 -->
    <div class="receipt-header">
      <div class="header-row receipt-num-row">
        <div class="header-item">
          <span class="label">缴费时间：</span>
          <span class="value" :contenteditable="editMode">{{ printPayFeeInfo.feeTime }}</span>
        </div>
        <div class="header-item right">
          <span class="label">缴费单号：</span>
          <span class="value" :contenteditable="editMode">{{ printPayFeeInfo.receiptNum }}</span>
        </div>
      </div>
      <div class="header-row">
        <div class="header-item">
          <span class="label">小区：</span>
          <span class="value" :contenteditable="editMode">{{ printPayFeeInfo.communityName }}</span>
        </div>
        <div class="header-item">
          <span class="label">房号：</span>
          <span class="value nowrap-value" :contenteditable="editMode">{{ printPayFeeInfo.roomName }}</span>
        </div>
        <div class="header-item right">
          <span class="label">业主：</span>
          <span class="value" :contenteditable="editMode">{{ printPayFeeInfo.payObjName }}</span>
        </div>
      </div>
    </div>

    <!-- 费用明细表 -->
    <table class="fee-table">
      <thead>
        <tr>
          <th style="width: 13%;" :contenteditable="editMode">收费项目</th>
          <th style="width: 30%;" :contenteditable="editMode">说明</th>
          <th style="width: 9%;" :contenteditable="editMode">面积</th>
          <th style="width: 8%;" :contenteditable="editMode">数量</th>
          <th style="width: 9%;" :contenteditable="editMode">单价</th>
          <th style="width: 11%;" :contenteditable="editMode">金额</th>
          <th style="width: 20%;" :contenteditable="editMode">备注</th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="(item, index) in printPayFeeInfo.fees" :key="index">
          <td :contenteditable="editMode">{{ item.feeName }}</td>
          <td :contenteditable="editMode">
            <div v-if="item.preDegrees">
              <div class="date-line">{{ dateFormat(item.startTime) }} 至 {{ dateFormat(item.endTime) }}</div>
              起止读数：{{ item.preDegrees }} 至 {{ item.curDegrees }}
            </div>
            <div v-else-if="item.feeTypeCd == '888800010006'">-</div>
            <div v-else class="date-line">
              {{ dateFormat(item.startTime) }} 至 {{ dateFormat(item.endTime) }}
            </div>
          </td>
          <td :contenteditable="editMode">{{ item.area || '-' }}</td>
          <td :contenteditable="editMode">{{ item.cycle || '-' }}</td>
          <td :contenteditable="editMode">{{ formatPrice(item.squarePrice) }}</td>
          <td :contenteditable="editMode">{{ item.amount }}</td>
          <td :contenteditable="editMode">{{ item.remark || '' }}</td>
        </tr>
      </tbody>
    </table>

    <!-- 合计 -->
    <div class="amount-row">
      <span class="label">金额合计：</span>
      <span class="value" :contenteditable="editMode">{{ changeNumMoneyToChinese(printPayFeeInfo.amount) }}</span>
      <span class="label">（小写）¥</span>
      <span class="value" :contenteditable="editMode">{{ printPayFeeInfo.amount }}</span>
    </div>

    <!-- 底部信息 -->
    <div class="receipt-footer">
      <div class="footer-row">
        <div class="footer-item">
          <span class="label">缴费方式：</span>
          <span class="value" :contenteditable="editMode">{{ paymentMethod }}</span>
        </div>
        <div class="footer-item">
          <span class="label">收费员：</span>
          <span class="value" :contenteditable="editMode">{{ printPayFeeInfo.userName }}</span>
        </div>
        <div class="footer-item right">
          <span class="label">打印时间：</span>
          <span class="value" :contenteditable="editMode">{{ printPayFeeInfo.printTime }}</span>
        </div>
      </div>

    </div>

    <div class="paper-selector">
      <span class="paper-label">纸张类型：</span>
      <el-radio-group v-model="paperType" size="small">
        <el-radio-button label="p1">一联(279mm)</el-radio-button>
        <el-radio-button label="p2">二联(140mm)</el-radio-button>
        <el-radio-button label="p3">三联(93mm)</el-radio-button>
        <el-radio-button label="a4l">A4横向</el-radio-button>
        <el-radio-button label="a4p">A4纵向</el-radio-button>
      </el-radio-group>
    </div>
    <div class="fit-warning" v-if="fitOverflow">费用明细较多，已缩至最小字号，超出部分将打印到下一联</div>

    <!-- 打印按钮 -->
    <el-row id="print-btn" style="margin-top: 30px;">
      <el-col :span="24" class="text-right">
        <el-button type="primary" @click="handlePrint">
          <i class="fa fa-check"></i>&nbsp;打印
        </el-button>
        <el-button type="warning" style="margin-right:20px;" @click="handleClose">
          取消
        </el-button>
      </el-col>
    </el-row>
  </div>
</template>

<script>
import { getCommunityId, getCommunityName } from '@/api/community/communityApi'
import { queryFeeReceipt, queryFeeReceiptDetail, queryFeeDetailDiscount } from '@/api/fee/printPayFeeApi'
import { getUserName } from '@/api/user/userApi'
import { dateFormat as formatDate, getDateStr } from '@/utils/dateUtil'
import { changeNumMoneyToChinese } from '@/utils/moneyUtil'

export default {
  name: 'PrintPayFeeBeiLin',
  data() {
    return {
      printPayFeeInfo: {
        communityName: '',
        receiptId: '',
        receiptIds: '',
        detailIds: '',
        merge: '',
        roomName: '',
        receiptNum: '',
        amount: 0.00,
        fees: [],
        feeTime: '',
        payObjName: '',
        feeReceipt: [],
        userName: '',
        printTime: ''
      },
      communityId: '',
      paperType: localStorage.getItem('beilinReceiptPaperType') || 'p2',
      fitOverflow: false,
      editMode: false
    }
  },
  watch: {
    paperType(val) {
      localStorage.setItem('beilinReceiptPaperType', val)
      this.applyPageStyle()
      this.fitToPage()
    }
  },
  computed: {
    // 缴费方式：取费用明细中的支付方式去重合并（可能存在账户抵扣+现金组合）
    paymentMethod() {
      const methods = []
      ;(this.printPayFeeInfo.fees || []).forEach(item => {
        if (item.primeRate && methods.indexOf(item.primeRate) < 0) {
          methods.push(item.primeRate)
        }
      })
      return methods.length > 0 ? methods.join('/') : '-'
    }
  },
  created() {
    console.log('printPayFeeBeiLin created')
    this.communityId = getCommunityId()
    this.printPayFeeInfo.userName = getUserName()
    this.printPayFeeInfo.printTime = getDateStr()
    this.applyPageStyle()
    this.initData()
  },
  methods: {
    initData() {
      this.printPayFeeInfo.receiptId = this.$route.query.receiptId
      this.printPayFeeInfo.receiptIds = this.$route.query.receiptIds
      this.printPayFeeInfo.detailIds = this.$route.query.detailIds
      this.printPayFeeInfo.merge = this.$route.query.merge
      this.printPayFeeInfo.communityName = getCommunityName()
      console.log('initData, receiptId:', this.printPayFeeInfo.receiptId)
      this.loadReceipt()
    },
    loadReceipt() {
      const params = {
        page: 1,
        row: 30,
        receiptId: this.printPayFeeInfo.receiptId,
        receiptIds: this.printPayFeeInfo.receiptIds,
        detailIds: this.printPayFeeInfo.detailIds,
        communityId: this.communityId
      }
      console.log('loadReceipt params:', params)

      queryFeeReceipt(params).then(response => {
        const feeReceipt = response.data
        console.log('feeReceipt:', feeReceipt)
        let amount = 0
        feeReceipt.forEach(item => {
          amount += parseFloat(item.amount || 0)
        })

        this.printPayFeeInfo.amount = amount.toFixed(2)
        if (feeReceipt.length > 0) {
          this.printPayFeeInfo.roomName = this.trimRoomName(feeReceipt[0].roomName || feeReceipt[0].objName)
          this.printPayFeeInfo.payObjName = feeReceipt[0].payObjName
          this.printPayFeeInfo.feeTime = feeReceipt[0].createTime
          this.printPayFeeInfo.receiptNum = feeReceipt[0].receiptCode || ''
        }
        this.printPayFeeInfo.feeReceipt = feeReceipt
        this.loadReceiptDetail()
      }).catch(error => {
        console.error('查询收据失败', error)
      })
    },
    loadReceiptDetail() {
      const params = {
        page: 1,
        row: 100,
        receiptId: this.printPayFeeInfo.receiptId,
        receiptIds: this.printPayFeeInfo.receiptIds,
        detailIds: this.printPayFeeInfo.detailIds,
        communityId: this.communityId,
        mergeFee: this.printPayFeeInfo.merge
      }
      console.log('loadReceiptDetail params:', params)

      queryFeeReceiptDetail(params).then(response => {
        const feeReceiptDetails = response.data
        console.log('feeReceiptDetails:', feeReceiptDetails)

        feeReceiptDetails.forEach(item => {
          this.printPayFeeInfo.feeReceipt.forEach(im => {
            if (item.receiptId == im.receiptId) {
              item.objName = im.objName
              item.feeTypeCd = im.feeTypeCd
            }
          })
          this.loadFeeDetailDiscount(item.detailId, item)
        })
        this.printPayFeeInfo.fees = feeReceiptDetails
        console.log('fees set:', this.printPayFeeInfo.fees)
        this.fitToPage()
      }).catch(error => {
        console.error('查询收据详情失败', error)
      })
    },
    loadFeeDetailDiscount(detailId, item) {
      const params = {
        page: 1,
        row: 100,
        detailId: detailId
      }

      queryFeeDetailDiscount(params).then(response => {
        const feeReceiptDetails = response.data
        if (feeReceiptDetails && feeReceiptDetails.length > 0) {
          feeReceiptDetails.forEach(data => {
            if (data.discountType == '2002') {
              item.discountPrice = parseFloat(data.discountPrice) * -1
            } else {
              item.discountPrice = 0
            }
          })
        } else {
          item.discountPrice = 0
        }
      }).catch(error => {
        console.error('查询折扣失败', error)
        item.discountPrice = 0
      })
    },
    dateFormat(date) {
      if (!date) return ''
      return formatDate(date)
    },
    formatPrice(price) {
      if (!price && price !== 0) return '-'
      return String(price).split('/')[0]
    },
    trimRoomName(name) {
      if (!name) return ''
      const match = name.match(/(\d+[号楼栋幢].*)$/)
      return match ? match[1] : name
    },
    changeNumMoneyToChinese,
    applyPageStyle() {
      const pageSizes = {
        p1: 'size: 241mm 279mm;',
        p2: 'size: 241mm 140mm;',
        p3: 'size: 241mm 93mm;',
        a4l: 'size: A4 landscape;',
        a4p: 'size: A4 portrait;'
      }
      let styleEl = document.getElementById('beilin-page-style')
      if (!styleEl) {
        styleEl = document.createElement('style')
        styleEl.id = 'beilin-page-style'
        document.head.appendChild(styleEl)
      }
      styleEl.textContent = '@media print { @page { ' + (pageSizes[this.paperType] || '') + ' margin: 5mm; } }'
    },
    // 自动缩放：费用明细不固定，按实际内容高度等比缩小字号/行距，确保整张收据在一联纸内
    fitToPage() {
      this.$nextTick(() => {
        const container = this.$el
        const paperHeights = { p1: 279, p2: 140, p3: 93, a4l: 210, a4p: 297 }
        const paperHeight = paperHeights[this.paperType] || 140
        // 可用内容高度(px)：纸高 - 上下页边距10mm - 容器上下内边距10mm
        const availPx = (paperHeight - 20) * 96 / 25.4
        const varNames = ['--title-size', '--body-size', '--amount-size', '--note-size', '--cell-pad-y']
        // 清除上次的缩放覆盖，读取当前纸型的基础字号
        varNames.forEach(v => container.style.removeProperty(v))
        const computed = getComputedStyle(container)
        const base = {}
        varNames.forEach(v => {
          base[v] = parseFloat(computed.getPropertyValue(v))
          if (isNaN(base[v])) base[v] = 4
        })
        const measure = () => {
          let needed = 0
          container.querySelectorAll('.receipt-title, .receipt-header, .fee-table, .amount-row, .receipt-footer').forEach(el => {
            needed += el.offsetHeight
          })
          // 约19mm的各区块垂直间距 + 打印渲染误差安全余量
          return needed + 90
        }
        const apply = scale => {
          varNames.forEach(v => container.style.setProperty(v, base[v] * scale + 'pt'))
        }
        // 针式可读下限：正文不小于7pt，低于此宁可不缩，超出部分续打下一联
        const MIN_BODY_PT = 7
        const minScale = Math.min(1, MIN_BODY_PT / base['--body-size'])
        let scale = 1
        while (scale > minScale && measure() > availPx) {
          scale = Math.max(minScale, Math.round((scale - 0.05) * 100) / 100)
          apply(scale)
        }
        // 已到可读下限仍放不下时提示，超出部分会续打到下一联
        this.fitOverflow = measure() > availPx
      })
    },
    handlePrint() {
      // 打印前刷新时间，确保与实际打印时刻一致
      this.printPayFeeInfo.printTime = getDateStr()
      this.$nextTick(() => {
        document.getElementById('print-btn').style.display = 'none'
        window.print()
        window.opener = null
        window.close()
      })
    },
    handleClose() {
      window.opener = null
      window.close()
    }
  }
}
</script>

<style>
.print-pay-fee-beilin-container {
  --title-size: 22pt;
  --body-size: 13pt;
  --amount-size: 14pt;
  --note-size: 12pt;
  --cell-pad-y: 4pt;
  width: 210mm;
  margin: 0 auto;
  padding: 8mm;
  box-sizing: border-box;
  color: #000;
  font-family: 'SimSun', '宋体', serif;
  font-size: var(--body-size);
  background: #fff;
}

.print-pay-fee-beilin-container.paper-p1 {
  min-height: 269mm;
}

.print-pay-fee-beilin-container.paper-p2 {
  --title-size: 18pt;
  --body-size: 11pt;
  --amount-size: 12pt;
  --note-size: 10pt;
  min-height: 130mm;
}

.print-pay-fee-beilin-container.paper-p3 {
  --title-size: 14pt;
  --body-size: 9pt;
  --amount-size: 10pt;
  --note-size: 8pt;
  --cell-pad-y: 2pt;
  min-height: 83mm;
}

.print-pay-fee-beilin-container.paper-a4l {
  width: 275mm;
  min-height: 190mm;
}

.print-pay-fee-beilin-container.paper-a4p {
  --title-size: 18pt;
  --body-size: 11pt;
  --amount-size: 12pt;
  --note-size: 10pt;
  width: 190mm;
  min-height: 277mm;
}

/* 针式纸型：整体加粗（宋体加粗为双重描绘，笔画加厚一倍，避免点阵丢失造成笔画空点） */
.print-pay-fee-beilin-container.paper-p1,
.print-pay-fee-beilin-container.paper-p2,
.print-pay-fee-beilin-container.paper-p3 {
  font-weight: bold;
}

.receipt-title {
  text-align: center;
  font-size: var(--title-size);
  font-weight: bold;
  letter-spacing: 2pt;
  margin-bottom: 5mm;
}

.paper-p2 .receipt-title,
.paper-p3 .receipt-title {
  letter-spacing: 1pt;
  margin-bottom: 2mm;
}

.paper-p3 .receipt-title {
  margin-bottom: 1mm;
}

.receipt-header {
  margin-bottom: 3mm;
}

.paper-p3 .receipt-header {
  margin-bottom: 1mm;
}

.header-row {
  display: flex;
  justify-content: space-between;
  line-height: 1.7;
  margin-bottom: 4px;
}

.header-row:last-child {
  margin-bottom: 0;
}

.header-item {
  flex: 1;
  display: flex;
  align-items: baseline;
}

.header-item.center {
  justify-content: center;
}

.header-item.right {
  justify-content: flex-end;
}

.header-item .label {
  flex-shrink: 0;
}

.header-item .value {
  display: inline-block;
  min-width: 5em;
  border-bottom: 1px solid #000;
  padding: 0 0.5em;
  text-align: center;
  max-width: 16em;
  word-break: break-all;
  white-space: normal;
}

/* 房号保持同一行显示，不换行 */
.header-item .value.nowrap-value {
  white-space: nowrap;
  word-break: keep-all;
}

.text-right {
  text-align: right;
}

.fee-table {
  width: 100%;
  border-collapse: collapse;
  margin-bottom: 3mm;
  font-size: var(--body-size);
}

.fee-table th,
.fee-table td {
  border: 1px solid #000;
  padding: var(--cell-pad-y) 2pt;
  text-align: center;
  vertical-align: middle;
}

.fee-table th {
  font-weight: bold;
  background: #f5f5f5;
}

/* 说明栏日期保持同一行，不自动换行 */
.fee-table td .date-line {
  white-space: nowrap;
}

.amount-row {
  display: flex;
  align-items: baseline;
  margin-bottom: 3mm;
  font-size: var(--amount-size);
  font-weight: bold;
  line-height: 1.7;
}

.amount-row .value {
  display: inline-block;
  min-width: 8em;
  border-bottom: 1px solid #000;
  margin: 0 2mm;
  text-align: center;
  flex: 1;
}

.receipt-footer {
  margin-top: 20px;
}

.paper-p2 .receipt-footer,
.paper-p3 .receipt-footer {
  margin-top: 3mm;
}

.footer-row {
  display: flex;
  justify-content: space-between;
  line-height: 1.7;
  margin-bottom: 4px;
  /* 底部信息（缴费方式/收费员/打印时间）保持同一行，不换行 */
  white-space: nowrap;
}

.footer-item {
  flex: 1;
  display: flex;
  align-items: baseline;
}

.footer-item.right {
  justify-content: flex-end;
}

.footer-item .value {
  padding: 0 4px;
}

.footer-note {
  text-align: left;
  font-size: var(--note-size);
  line-height: 1.6;
  margin-top: 2mm;
}

.paper-selector {
  margin-top: 20px;
  text-align: center;
}

.paper-selector .paper-label {
  font-size: 14px;
  margin-right: 8px;
}

.fit-warning {
  margin-top: 8px;
  text-align: center;
  color: #E6A23C;
  font-size: 13px;
}

/* ===== 编辑模式样式 ===== */
.edit-toolbar {
  margin-bottom: 10px;
  text-align: left;
}

/* 编辑模式下可编辑元素显示淡黄色底色，提示用户可点击修改 */
.edit-mode [contenteditable="true"] {
  background-color: #FFF9E6;
  outline: 1px dashed #E6A23C;
  cursor: text;
  transition: background-color 0.2s;
}

.edit-mode [contenteditable="true"]:focus {
  background-color: #FFF3CC;
  outline: 1px solid #E6A23C;
}

/* 编辑模式下表格单元格可编辑态的内边距修正，避免虚线框挤压内容 */
.edit-mode .fee-table [contenteditable="true"]:focus {
  outline-offset: -1px;
}

@media print {
  /* 清零 body 默认边距，避免挤占可用宽度导致右侧裁字 */
  body {
    margin: 0 !important;
  }

  #print-btn,
  .paper-selector,
  .fit-warning,
  .edit-toolbar {
    display: none !important;
  }

  /* 打印时清除编辑态的视觉提示，确保收据干净输出 */
  .print-pay-fee-beilin-container [contenteditable="true"] {
    background-color: transparent !important;
    outline: none !important;
    cursor: default !important;
  }

  .print-pay-fee-beilin-container {
    padding: 5mm;
  }
}
</style>
